module.exports = __webpack_public_path__ + "img/about-bg.7a15eea4.jpg";